import { ApiRequestInterceptorQS } from "./apiRequestQS";
import { ORDENES } from "../Constants/Endpoinst";

const ENDPOINT = ORDENES.ordenes;

// Wrapper genérico para llamada al endpoint de órdenes
const callOrdenesApi = (method, qs) =>
  ApiRequestInterceptorQS(ENDPOINT, method, qs);

/**
 * GET resumen de órdenes (vista_ordenes_resumen)
 */
export const getOrdenesResumen = async () => {
  const { code, data } = await callOrdenesApi("GET", {
    solicitud: "resumen",
  });
  return { code, data };
};
